import { render, staticRenderFns } from "./ImageDetails.vue?vue&type=template&id=0a1c82fb&"
import script from "./ImageDetails.vue?vue&type=script&lang=ts&"
export * from "./ImageDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ImageDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports